import Param from '../../param';
import Util from '../../util';
import effectManager from '../effect';
import Pararax from './pararax';
import ScrollAnimation from './scrollanimation';
import Pager from './pager';
import Contents from './contents';

let pararax;
let scrollAnimation;
let pager;
let contents;


export default class smoothScrollManager{
    constructor(inc){

        pararax = new Pararax();
        scrollAnimation = new ScrollAnimation();
        pager = new Pager();
        contents = new Contents();

        this.w = $(window).innerWidth();
        this.h = $(window).innerHeight();

        this.$container = $("#l-scroll");
        this.$body = $("#l-scroll-body");
        /* 臨時 */
        this.$fixcnt = $("#p-column-modal-contents");
        this.$spMovecnt = $("#body-bg");
        // this.$prarax = $('.js__psc');
        // this.$target = $('.js__tsc');
        this.$prarax;
        this.$target;
        this.$scrollDown = $("#c-scrolldown");
        this.$backBtn = $("#c-back");

        this.$htmlBody = $("body");


        this.flg = false;


        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;

        this.paraPoint = [];

        this.scrollLimit = 0; // scroll limit

        this.timer = [];

        this.type = "normal";

        this.inertia = (Useragnt.mobile||Useragnt.tablet)?false:true; /* 慣性スクロールを有効にするか */

        this.pageKvOutFlg = false;


        /* 状態監視用のフラグ */
        this.status = {
            controll : false, /* ページャーなどで操作しているか */
            comp     : false, /* 慣性スクロールが完了したか */
        }

        this.webglStop = false; /* KVが画面外なら止める */

    }
    init(){

        let _this = this;

        // pager.init();
        pararax.init();
        if(!this.inertia) $("body").addClass("is-inertia-none");

        /* pager操作 */
        // pager.$list.on("click",function(){
        //     let _select = $(this).data("current");
        //     if(_select===0){
        //         $('html,body').animate({ scrollTop: 0 }, '1');
        //     }else{
        //         $('html,body').animate({ scrollTop: pager.point[_select-1] }, '1');
        //     }
        // });
        $("#l-pagetop").on("click",function(){
            $('html,body').animate({ scrollTop: 0 }, '1');
        });

    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */
        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        // this.prevInc = this.inc;
        this.mode = "scroll";
        this.status.comp = false;
    }
    move() {

        // let add = (this.inertia) ?0.08:1;
        let add = (this.inertia) ?0.08:0.1;

        this.nowInc +=  add * (this.inc - this.nowInc);
        this.nowInc = Math.floor(this.nowInc*10 )/10;


        /* フルスクリーン制御用 */
        // let _y = util.map(this.inc, 0, -(this.scrollLimit - this.h), 0, 1);
       // this.nowInc += add * (_y - this.nowInc);

        this.trans();

    }
    trans() {

        let _this = this;

        if(this.nowInc<=10) this.scrollLimit = ($(".p-section.is-current")[0])?$(".p-section.is-current .p-page-body-scroll").innerHeight() - window.innerHeight:0;


        if(this.inertia){
            TweenMax.set(this.$body,{y:-this.nowInc});
        }
        /* スクロール連動で動作 */
        pararax.check(this.nowInc);
        // pager.update(this.nowInc,this.dir,this.h);
        contents.update(this.nowInc);

        /* アニメーション対象の要素があるかチェック */
        scrollAnimation.check(
            this.nowInc,
            this.h,
            pager.$target.eq(pager.current)
        );


        if(this.h<this.nowInc){
            this.webglStop = true;
        }else{
            this.webglStop = false;
        }

        if(this.prevInc == this.nowInc){
            this.onComplete();
        }
        this.prevInc = this.nowInc;
    }

    resize (display) {
        if($("#l-root").hasClass("is-modal-open")) return;
        this.w = $(window).innerWidth();
        // this.h = $(window).innerHeight();
        this.h = $(window).height();
        // this.scrollLimit = ($(".p-section.is-current")[0])?$(".p-section.is-current .p-page-body-scroll").innerHeight() - window.innerHeight:0;


        $("#l-root").css({"height":this.$body.innerHeight()});

        pararax.resize(this.h);
        scrollAnimation.resize(this.h);
        contents.resize(this.h);
        // pager.resize(display);
    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        if(this.status.comp) return;
        this.status.comp = true;




    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}